import { FC } from "react";

import {
  ICustomField,
  IExtendableDto,
  IRydeHeaderGroup,
  IRydeRow,
  NO_GROUPING_QS_VALUE,
} from "@ryde/shared";

import { GridTable } from "../../../grid";
import { useTableNestedGrid } from "./parts";
import { TableNestedWrapper } from "./ride-nested-grid.styled";

export const RideNestedGridTemplate: FC<ICustomField> = () => {
  const { table } = useTableNestedGrid();
  const rows = table?.getRowModel()?.rows;

  return (
    <TableNestedWrapper data-e2e-grouping-value={NO_GROUPING_QS_VALUE}>
      <GridTable
        headerGroups={
          table.getHeaderGroups() as unknown as IRydeHeaderGroup<IExtendableDto>[]
        }
        rows={rows as unknown as IRydeRow<IExtendableDto>[]}
      />
    </TableNestedWrapper>
  );
};
